import React, { useState, useContext, useEffect, useRef } from 'react';
import { Field } from 'formik';
import InputField from '../Form/InputField';
import { AuthContext, LoaderContext } from '../../contexts';
import ComboBox from '../Form/ComboBox3';
import CheckBox from '../Form/CheckBoxFormSection';
import CheckBoxGroup from "../Form/CheckBoxGroup";
import MultiSelectField from '../Form/MultiSelectField';
import SearchField from '../Form/SearchField';
import _, { camelCase, debounce, isObject, uniqueId } from 'lodash';
import { DayPicker } from "react-day-picker";
import Label from '../Form/Label';
import Switch from 'react-switch';
import Colors from 'constants/Colors';
import TextField from '../Form/TextField';
import Icon from '../Icon';
import moment from 'moment';
import TextEditorBox from "../TextEditorBox";
import NotesAccordionV2 from '../NotesAccordionV2';
import RadioButtonGroup from "../Form/Radio/RadioButtonGroup";
import { useGetPersonsSync, useGetSicCode } from '../../services/PersonService';
import {
    useGetCountries,
    useGetZipCode,
    useGetSerpro,
    useGetSerproEnterprise,
    useGetQuery
} from '../../services/QuestionnairesService';
import { MessageCenter } from '../../utils';

import { FieldWrapper, Container, CalendarContainer, BorderSwitch, AddButton, BottomSeparatorLine } from './styles'
import DragZoneUpload from '../DragZoneUpload/index';
import TagsList from '../TagList/index';
import ModalConfirmation from '../ModalConfirmation';
import EndorsementTagList from '../EndorsementTagList'
import ptBR from 'date-fns/locale/pt-BR';

const getFieldComponent = (question) => {
    const { idDomainQuestion, idQuestion, behaviorObject } = question;

    if (idDomainQuestion === 42) {
        switch (behaviorObject?.componentId) {
            case "TextEditorBox": return TextEditorBox;
            case "TextField": return TextField;
            case "NotesAccordion": return NotesAccordionV2;
            default: return InputField;
        }
    } else if (idDomainQuestion == 43) {
        switch (behaviorObject?.componentId) {
            case "RadioButton": return RadioButtonGroup;
            case "CheckBox": return CheckBox;
            default: return ComboBox;
        };
    } else if (idDomainQuestion === 44) {
        switch (behaviorObject?.componentId) {
            //case "CheckBox": return CheckBoxGroup;
            default: return MultiSelectField;
        };
    } else if (idDomainQuestion === 276) {
        return SearchField;
    } else if (idDomainQuestion === 295) {
        return InputField;
    } else if (idDomainQuestion === 277) {
        return InputField;
    }
}

const getOptions = (question, idProduct, idDomainStatusFilter) => {
    if (![43, 44, 270, 271].includes(question.idDomainQuestion)) return [];

    if (question.answerOptions) {
        const answerOptions = question.answerOptions.map(answerOption => {
            let behavior = {}

            if (idDomainStatusFilter) {
                if (
                    !Array.isArray(answerOption?.behaviorObject?.idDomainStatusFilter) &&
                    answerOption?.behaviorObject?.idDomainStatusFilter !== idDomainStatusFilter
                ) {
                    return null;
                } else if (
                    Array.isArray(answerOption?.behaviorObject?.idDomainStatusFilter) &&
                    !answerOption?.behaviorObject?.idDomainStatusFilter.includes(idDomainStatusFilter)
                ) {
                    return null;
                }
            }

            try {
                behavior = JSON.parse(answerOption.behaviorAnswerOption) || {}
            } catch (e) {
                //console.error('GET OPTIONS - Error in parse Behavior')
            }

            if (behavior?.isResultProduct) {
                const hasProduct = behavior.resultIdProduct.some(resultId => resultId == idProduct);

                if (hasProduct) {
                    return {
                        label: answerOption.dsAnswerOption,
                        expireDateAnswerOption: answerOption.expireDateAnswerOption,
                        value: {
                            idAnswerOption: answerOption.idAnswerOption,
                            dsAnswerOption: answerOption.dsAnswerOption,
                            resultValue: behavior.resultValue != null ? behavior.resultValue : null,
                        }
                    }
                }
            } else {
                return {
                    label: answerOption.dsAnswerOption,
                    expireDateAnswerOption: answerOption.expireDateAnswerOption,
                    value: {
                        idAnswerOption: answerOption.idAnswerOption,
                        dsAnswerOption: answerOption.dsAnswerOption,
                        resultValue: behavior.resultValue != null ? behavior.resultValue : null,
                    }
                }
            }
        })


        return answerOptions.filter(Boolean);
    }

    return [];
}

const getQuestionAnswer = (question, setFieldValue) => {
    if (!question) return '';
    if (question.answer == null) question.answer = '';

    //question with options answer
    if (question.idDomainQuestion === 43) {
        if (isNaN(question.behaviorObject.defaultValue)) question.behaviorObject.defaultValue = null;
        if (!question?.idAnswerOption && !question.behaviorObject.defaultValue && question.behaviorObject.componentId === 'Switch') {
            const currentAnswerOption = question?.answerOptions?.find((x) => x.dsAnswerOption?.toUpperCase() === 'NO');
            if (currentAnswerOption) {
                question.idAnswerOption = currentAnswerOption.idAnswerOption
                question.behaviorObject.defaultValue = currentAnswerOption.idAnswerOption;
            }
        }

        if (!question?.idAnswerOption && !question.behaviorObject.defaultValue) return;
        if (!question?.idAnswerOption && question.behaviorObject.defaultValue && !isNaN(question.behaviorObject.defaultValue)) question.idAnswerOption = question.behaviorObject.defaultValue;
        if (!question.idAnswerOption) return;

        let dsAnswerOption;
        let resultValue = null;
        try {
            const currentAnswerOption = question?.answerOptions?.find((x) => x.idAnswerOption === question?.idAnswerOption);
            const { behaviorObject } = currentAnswerOption || {};

            dsAnswerOption = currentAnswerOption?.dsAnswerOption;
            resultValue = behaviorObject?.resultValue != null ? behaviorObject?.resultValue : null;
        } catch (err) {
            console.error(`quotation-edit - checkType: idAnswerOption: ${question.idAnswerOption} - ERROR: ${err.message}`);
        }

        if (!question.answer && dsAnswerOption) question.answer = (resultValue != null ? resultValue : dsAnswerOption) || "";
        setFieldValue && setFieldValue(question.key, {
            idAnswerOption: question?.idAnswerOption,
            dsAnswerOption: dsAnswerOption || "",
            resultValue
        });
        return;
    }

    //questions with calendar
    if (question.behaviorObject.rightIcon === "calendar") {
        let formattedDate = ""
        if (question.answer) {
            let momentDate = moment(question.answer, 'YYYY-MM-DD');
            if (momentDate.isValid()) {
                formattedDate = momentDate.format(question.behaviorObject.fieldDateFormat || 'MM/DD/YYYY');
                question.answer = momentDate.format("YYYY-MM-DD");
            }
        }

        question.answer = question.answer
        setFieldValue && setFieldValue(question.key, formattedDate);
        return;
    }

    if (question.idDomainQuestion === 270 || question.idDomainQuestion === 271) {
        try {
            let answerJson = JSON.parse(question.answerJson) || [];
            question.answer = answerJson
        } catch (error) {
            if (Array.isArray(question.answer)) {
                question.answer = question.answerJson;
            } else {
                question.answer = []
            }
            //console.log('ERROR IN PARSE', question);
            return;
        }
    }

    //question with string or json answer
    try {
        let answerJson = JSON.parse(question.answerJson);

        if (answerJson && answerJson.constructor === Object) {
            question.answer = question?.answer || question.behaviorObject.defaultValue || ''
            setFieldValue && setFieldValue(question.key, answerJson?.value || question.behaviorObject.defaultValue || '');
            return;
        } else {
            question.answer = question?.answer || question.behaviorObject.defaultValue || ''
            setFieldValue && setFieldValue(question.key, question?.answer || question.behaviorObject.defaultValue || '');
            return;
        }
    } catch (error) {
        //console.log('ERROR IN PARSE', question);
        question.answer = question?.answer || question.behaviorObject.defaultValue || ''
        setFieldValue && setFieldValue(question.key, question?.answer || question.behaviorObject.defaultValue || '');
        return;
    }
}

const getDisableDays = (days) => {
    if (days == null) {
        return null;
    };
    const date = new Date();
    return new Date(date.setDate(date.getDate() + (days)));
};

export default function FormSection({
    sectionName,
    questionnaire,
    values,
    setFieldValue,
    sectionIndex,
    extraButtons,
    extraButtonsQuestion,
    onQuestionChange,
    periodicityText,
    periodicityOptions,
    idProduct,
    onClickCreatePerson,
    operationIdPerson,
    disableAll,
    errors,
    setFieldError,
    idDomainStatusFilter,
    singleUpload,
    onBlur,
    canGenerate,
    question901SearchAllCountry,
    currentModality,
    ignoreModality,
    refreshCompanyClientInformation,
    onRequestSerproCnpj,
    showWarning,
    format,
    onSearchZipCode,
    permissions = {},
    setQuestionnaire,
    customTagListBg,
    selectedBrokers,
    selectedCoInsurers,
    debounceSearchRequest = true,
    idOperation,
    contextOfApp,
    extraButtonsAfterQuestion,
    selectedPersons,
    replaceQuery
}) {
    
    const mc = new MessageCenter();
    const authContext = useContext(AuthContext);
    const [showCalendar, setShowCalendar] = useState("");
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const isMultipleFormSection = sectionIndex != null;
    const permissionsValues = Object.values(permissions);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalPromise, setModalPromise] = useState({ resolve: () => { }, reject: () => { } });
    
    const {
        request: getPersonRequest,
    } = useGetPersonsSync();

    const {
        request: getSicCodeRequest,
    } = useGetSicCode();

    const {
        request: getCountryRequest,
    } = useGetCountries();

    const {
        request: getSerproRequest,
    } = useGetSerproEnterprise();

    const {
        request: getZipCodeRequest,
    } = useGetZipCode();

    const {
        request: useGetQueryRequest,
    } = useGetQuery();

    const cpfValidation = (cpf) => {
        let sum;
        let rest;
        sum = 0;
        if (cpf == "00000000000") return false;

        for (let i = 1; i <= 9; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        rest = (sum * 10) % 11;

        if ((rest == 10) || (rest == 11)) rest = 0;
        if (rest != parseInt(cpf.substring(9, 10))) return false;

        sum = 0;
        for (let i = 1; i <= 10; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
        rest = (sum * 10) % 11;

        if ((rest == 10) || (rest == 11)) rest = 0;
        if (rest != parseInt(cpf.substring(10, 11))) return false;
        return true;
    }

    const cnpjValidation = (cnpj) => {
        let position = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

        if (cnpj.length !== 14)
            return false

        if (/0{14}/.test(cnpj))
            return false

        for (var i = 0, n = 0; i < 12; n += cnpj[i] * position[++i]);
        if (cnpj[12] != (((n %= 11) < 2) ? 0 : 11 - n))
            return false

        for (var i = 0, n = 0; i <= 12; n += cnpj[i] * position[i++]);
        if (cnpj[13] != (((n %= 11) < 2) ? 0 : 11 - n))
            return false

        return true
    }

    const validateCpfCnpj = async (question, searchValue, queryId) => {
        if (queryId === "fitGetSerproCpnj" || !searchValue) return;

        let message = ""
        if (question.behaviorObject?.fieldMask === "cpf") {
            if (!cpfValidation(searchValue)) message = `CPF ou CNPJ inválido`
        }

        if (question.behaviorObject?.fieldMask === "cnpj") {
            if (!cnpjValidation(searchValue)) message = `CPF ou CNPJ inválido`
        }

        if (question.behaviorObject?.fieldMask === "cpfCnpj") {
            if (searchValue && searchValue.length > 11) {
                if (!cnpjValidation(searchValue)) message = `CPF ou CNPJ inválido`
            } else if (searchValue) {
                if (!cpfValidation(searchValue)) message = `CPF ou CNPJ inválido`
            }
        }

        if (message) {
            setFieldError && setFieldError(question.key, message)
            mc.error(message);
        }
    }


    const handleOnChange = (question, value, questionnaire) => {
        if (question.disabled || question.behaviorObject.isReadOnly || question.behaviorObject.rightIcon === 'calendar') return;

        setFieldValue && setFieldValue(question.key, value);
        let questionnaireUpdated = questionnaire;

        if (!question.behaviorObject.searchQueryId || value === '') {
            const idAnswerOption = isObject(value) && value.idAnswerOption ? value.idAnswerOption : undefined;
            const answer = idAnswerOption ?
                (value.resultValue != null ? value.resultValue : value.dsAnswerOption) :
                isObject(value) ?
                    JSON.stringify(value) :
                    value;

            questionnaireUpdated = questionnaire.map(v => v.key === question.key ?
                ({
                    ...v, idAnswerOption,
                    answer: answer === '' ? v.answerJson = '' : answer,
                    answerJson: idAnswerOption ? undefined : v.answerJson
                }) : v)

            setQuestionnaire(questionnaireUpdated);
        }
        onQuestionChange && onQuestionChange(question, value, setFieldValue, questionnaireUpdated)
    };


    const debounceOnChange = useRef(debounce((question, value, questionnaire) => handleOnChange(question, value, questionnaire), 50))
        .current;

    //search request for search field types based on behavior
    const searchRequest = async (searchValue, question, setSearchList) => {
        try {
            let qstBehavior = question.behaviorObject;

            if (replaceQuery) {
                const hasQuery = replaceQuery.find((query) => query.searchQueryId === qstBehavior.searchQueryId);
                if (hasQuery) return setSearchList(hasQuery.values);
            }

            if (qstBehavior && qstBehavior.searchQueryId === 'person') {
                const query = { getContacts: true, getSicCode: true };

                if (qstBehavior.searchQueryFieldId === 'legalPersonId' && !searchValue) {
                    searchValue = 'xxxxxxxxxxxxxxxx'
                }

                query[qstBehavior.searchQueryFieldId] = searchValue;

                if (qstBehavior.searchIndividuals) {
                    query.idPersonRoot = authContext.idPersonRoot;
                    query.idDomain = 34
                } else {
                    if (qstBehavior.searchOperationIdPerson && operationIdPerson) {
                        query.idPersonRoot = operationIdPerson;
                    }
                    query.idDomain = 35
                }

                const { data } = await getPersonRequest(null, query);

                const persons = data.value.map(person => ({
                    ...person,
                    value: query.idDomain === 34 ? `${person.personFirstName} ${person.personLastName}` : person.personLastName,
                    id: person.idPerson
                }));

                return setSearchList(persons);
            }

            if (qstBehavior && qstBehavior.searchQueryId === 'sicCode') {
                const query = { sicType: 'TEXEL_MERIDIAN_US', searchValue };

                const { data } = await getSicCodeRequest(null, query);

                const sicCodes = data.value.map(sicCode => ({
                    ...sicCode,
                    value: sicCode.sicCode + " - " + sicCode.sicDescription,
                    id: sicCode.sicCode
                }));

                return setSearchList(sicCodes);
            }

            if (qstBehavior && qstBehavior.searchQueryId === 'country') {
                const query = { country: searchValue };

                if (!question901SearchAllCountry) {
                    if (question.idQuestion == 901) {
                        query.countryIds = [242, 221] //221 USA
                    }
                }

                const { data } = await getCountryRequest(null, query);

                const countries = data.value.map(country => ({
                    ...country,
                    value: country.countryName,
                    id: country.idCountry

                }));
                return setSearchList(countries);
            }

            if (qstBehavior?.searchQueryId === 'fitQueryPersonClient' || qstBehavior?.searchQueryId === 'fitQueryPersonClientLegalEntities' || qstBehavior?.searchQueryId === 'fitQueryPersonBroker') {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        id: qstBehavior?.searchQueryId,
                        queryTail: qstBehavior?.searchQueryId === 'fitQueryPersonClient' || qstBehavior?.searchQueryId === 'fitQueryPersonBroker',
                        personName: searchValue,
                        legalPersonId: searchValue,
                        brokerIdSelected: qstBehavior?.brokerIdSelected || null,
                        selectedBrokers: selectedBrokers,
                        questionId: question.idQuestion
                    }
                });

                try {
                    if (data.ret_code !== 200) return;

                    const persons = data.ret_value.map(person => ({
                        ...person,
                        value: (qstBehavior?.searchQueryId !== 'fitQueryPersonClient' || qstBehavior?.searchQueryId !== 'fitQueryPersonBroker') ? `${person.insurerBrokerId || person.legalPersonId || person.id} - ${person.personName}` : person.personName,
                        id: person.id
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err)
                };
            }

            if (["fitQueryBorrowerRepresentative", "fitGetSompoInsured"].includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        id: qstBehavior?.searchQueryId,
                        personName: searchValue,
                        legalPersonId: searchValue,
                        borrowerId: 554875 //554875
                    }
                });

                try {
                    if (data.ret_code !== 200) return;

                    const persons = data.ret_value.map(person => ({
                        ...person,
                        value: `${person.name || person.personName}${person.CONTACT_DESCRIPTION ? ` - ${person.CONTACT_DESCRIPTION}` : ''}`,
                        id: person.id
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err)
                };
            }

            if (["fitGetSompoCoInsurers"].includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        id: qstBehavior?.searchQueryId,
                        personName: searchValue,
                        selectedCoInsurers: selectedCoInsurers
                    }
                });

                try {
                    if (data.ret_code !== 200) return;

                    const persons = data.ret_value.map(person => ({
                        ...person,
                        value: person.value,
                        id: person.id
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err)
                };
            }

            if (["fitGetContactsByPersonRoot"].includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        id: qstBehavior?.searchQueryId,
                        idPerson: operationIdPerson,
                        personName: searchValue,
                        selectedPersons
                    }
                });

                try {
                    if (data.ret_code !== 200) return;

                    const persons = data.ret_value.map(person => ({
                        ...person,
                        value: person.name,
                        id: person.idPerson
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err)
                };
            }

            if (qstBehavior?.searchQueryId === "fitGetCompanyPerson") {
                const { data } = await useGetQueryRequest({
                    id: "fitGetCompanyPerson",
                    params: {
                    id: "fitGetCompanyPerson",
                    queryTail: true,
                    personName: searchValue,
                    },
                });
        
                try {
                    if (data.ret_code !== 200) return;
        
                    const persons = data.ret_value.map((person) => ({
                    ...person,
                    value: person.personName,
                    id: person.id,
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err);
                }
                }
        
                if (qstBehavior?.searchQueryId === "fitGetCountrySubDivisionsByCountryName") {
                const { data } = await useGetQueryRequest({
                    id: "fitGetCountrySubDivisionsByCountryName",
                    params: {
                    id: "fitGetCountrySubDivisionsByCountryName",
                    subdivisionName: qstBehavior.countryName?.dsAnswerOption || qstBehavior.countryName,
                    name: searchValue,
                    },
                });
        
                try {
                    if (data.ret_code !== 200) return;
        
                    const persons = data.ret_value.map((person) => ({
                    ...person,
                    value: person.SUBDIVISION_NAME,
                    id: person.ID_COUNTRY,
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err);
                }
                }
        
                const arrSearchList = ["getSlipLeader", "getLloydsLeader", "getLirmaLeader", "getSecondLloyds", "getSurplusLinesBroker"];
                if (arrSearchList.includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                    id: qstBehavior?.searchQueryId,
                    queryTail: true,
                    personName: searchValue,
                    idOperation,
                    isLirmaSearchQuery: qstBehavior?.searchQueryId === "getLirmaLeader",
                    selectedLloyds: qstBehavior?.selectedLloyds
                    },
                });
        
                try {
                    if (data.ret_code !== 200) return;
        
                    const persons = data.ret_value.map((person) => ({
                    ...person,
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err);
                }
                }
        
                if (qstBehavior?.searchQueryId === "fitGetTaxPayerPerson") {
                const { data } = await useGetQueryRequest({
                    id: "fitGetTaxPayerPerson",
                    params: {
                    id: "fitGetTaxPayerPerson",
                    queryTail: true,
                    personName: searchValue,
                    idOperation,
                    administeredByAnswer: qstBehavior?.administeredByAnswer || null,
                    },
                });
        
                try {
                    if (data.ret_code !== 200) return;
        
                    const persons = data.ret_value.map((person) => ({
                    ...person,
                    value: person.value,
                    id: person.id,
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err);
                }
                }
        
                if (qstBehavior?.searchQueryId) {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                    id: qstBehavior?.searchQueryId,
                    queryTail: true,
                    personName: searchValue,
                    idOperation,
                    },
                });
        
                try {
                    if (data.ret_code !== 200) return;
        
                    const persons = data.ret_value.map((person) => ({
                    ...person,
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err);
                }
                }

            return;
        } catch (err) {
            console.log("FETCH_FAILURE: ", err);
            return;
        }
    }

    const searchSerpro = async (question, searchValue, queryId, questionnaire, setFieldValue, adHoc = false) => {
        validateCpfCnpj(question, searchValue, queryId);

        if (searchValue && searchValue.length <= 11) return;

        if (queryId !== "fitGetSerproCpnj" || !searchValue) return;

        try {
            updateIsLoadingStatus(true)
            const { data } = await getSerproRequest(null, { id: searchValue, draft: true })
            if (data.ret_code !== 200) {
                onRequestSerproCnpj && onRequestSerproCnpj(question, {}, setFieldValue, adHoc)
                data.ret_value.trim() === "Nenhum registro encontrado."
                    ? mc.error(`${data.ret_value}`)
                    : mc.error("Erro durante a Consulta do CNPJ/CPF")
                return "";
            }

            onRequestSerproCnpj && onRequestSerproCnpj(question, data.ret_value, setFieldValue, adHoc)
        } catch (err) {
            onRequestSerproCnpj && onRequestSerproCnpj(question, {}, setFieldValue, adHoc)
            mc.error(`Erro durante a Consulta do CNPJ/CPF`);
        } finally {
            updateIsLoadingStatus(false)
        };
    }

    const searchZipCode = async (zipCode, queryId, setFieldValue, question) => {
        if (queryId !== "zipCode") return;
        if (question.disabledSearch) return;
        
        try {
            updateIsLoadingStatus(true)
            const { data } = await getZipCodeRequest(null, { zipcodeQuery: zipCode })
            if (data.ret_code !== 200) {
                mc.error(`CEP não encontrado!`);
                console.log("searchZipCode", data);
                return;
            }

            onSearchZipCode && onSearchZipCode(data.ret_value, setFieldValue, question)
        } catch (err) {
            console.log("searchZipCode", err)
        } finally {
            setTimeout(() => updateIsLoadingStatus(false), 300)
        };
    };

    //observer to send current questionnaire answers externally to other forms
    useEffect(() => {
        setFieldValue(`$ANSWERS_${sectionName}${sectionIndex != null ? `_${sectionIndex}` : ""}`, questionnaire);
    }, [questionnaire]);

    const handleRefreshPerson = async (question, idPerson) => {
        updateIsLoadingStatus(true)
        const { data, status } = await getPersonRequest(null, {
            getContacts: true,
            getSicCode: true,
            idDomain: 35,
            idPerson
        });

        if (status !== 200 || !data.value.length) return updateIsLoadingStatus(false)

        const person = data.value[0];

        const questionnaireUpdated = questionnaire.map(v => v.key === question.key ? ({
            ...v,
            answerJson: JSON.stringify({ value: person.personLastName, id: person.idPerson }),
            answer: JSON.stringify({ value: person.personLastName, id: person.idPerson })
        }) : v);

        setQuestionnaire(questionnaireUpdated);
        onQuestionChange(
            question,
            { value: person.personLastName, id: person.idPerson, ...person },
            setFieldValue,
            questionnaireUpdated
        )

        return updateIsLoadingStatus(false)
    }

    const handleActionButtons = (question) => {
        if (refreshCompanyClientInformation && !!question.behaviorObject.canRefreshPerson) {
            return <>
                <AddButton
                    type="button"
                    style={{ paddingLeft: 8 }}
                    onClick={() => onClickCreatePerson && onClickCreatePerson(
                        question,
                        setFieldValue,
                        onQuestionChange
                    )}
                >
                    <Icon name="addEdit" />
                </AddButton>
                <AddButton
                    type="button"
                    onClick={() => {
                        try {
                            const { id: idPerson } = JSON.parse(question.answer);
                            handleRefreshPerson(question, idPerson)
                        } catch (error) {
                            return
                        }
                    }}
                >
                    <Icon name="generate" />
                </AddButton>
            </>
        } else if ((!disableAll && !question.disabled) && !!question.behaviorObject.canCreatePerson) {
            return <AddButton
                type="button"
                style={{ paddingLeft: 8 }}
                onClick={() => onClickCreatePerson && onClickCreatePerson(
                    question,
                    setFieldValue,
                    onQuestionChange
                )}
            >
                <Icon name="addEdit" />
            </AddButton>
        } else {
            return <></>
        }
    }

    const handleDelete = () => {
        return new Promise((resolve, reject) => {
            setIsModalVisible(true);
            setModalPromise({ resolve, reject });
        });
    };
      
    const confirmDelete = () => {
        modalPromise.resolve(true);
        setIsModalVisible(false);
    };
    
    const confirmCancel = () => {
        modalPromise.resolve(false);
        setIsModalVisible(false);
    };

    return (
        <Container key={`${sectionName}-${sectionIndex}-section`}>
            {questionnaire
                .filter(question => {
                    return question.behaviorObject && question.behaviorObject.sectionName === sectionName;
                })
                .filter(question => {
                    const productPlans = question?.productPlans?.map(v => (+v));
                    return ignoreModality || !question.productPlans?.length || productPlans.includes(currentModality);
                })
                
                .map(question => {
                    const idDomainAccessFilter = question?.behaviorObject?.idDomainAccessFilter;
                    const idDomainAccessEditable = question?.behaviorObject?.idDomainAccessEditable;

                    if (idDomainAccessEditable && permissionsValues && permissionsValues.includes(idDomainAccessEditable)) {
                        question.behaviorObject.isReadOnly = false;
                    } else if (idDomainAccessEditable && permissionsValues) {
                        question.disabled = true;
                        question.behaviorObject.isReadOnly = true;
                    }

                    if (Array.isArray(idDomainAccessFilter)) {
                        if (!(!idDomainAccessFilter || !permissionsValues || permissionsValues.find(v => v && idDomainAccessFilter.includes(v)))) {
                            question.visibleQuestion = false;
                        } 
                    } else {
                        if (!(!idDomainAccessFilter || !permissionsValues || permissionsValues.includes(idDomainAccessFilter))) {
                            question.visibleQuestion = false;
                        }
                    }

                    if (values[question.key] == undefined) getQuestionAnswer(question, setFieldValue);

                    if (!question.key) question.key = `${camelCase(question.dsQuestion)}_${question.idQuestion}${isMultipleFormSection ? `_${sectionIndex}` : ""}_${uniqueId()}`;

                    if (!ignoreModality) {
                        const questionInTheSection = questionnaire.find(qst => qst.key === question.key);
                        if (questionInTheSection) return questionInTheSection;
                    }

                    return question
                }).map((question, questionIndex) => {
                    const fieldComponent = getFieldComponent(question);
                    if (!question.visibleQuestion) return <></>;

                    const idAnswerOption = question.idAnswerOption;
                    const answerOptions = question.answerOptions;
                    let warning = false;
                    let refused = false;

                    answerOptions.forEach((option) => {
                        const optionValue = option.idAnswerOption;

                        if (idAnswerOption === optionValue) {
                            if (option.idDomain === 40) {
                                warning = idAnswerOption;
                            } else if (option.idDomain === 38) {
                                refused = idAnswerOption;
                            }
                        }
                    });
                    return (<>
                        <React.Fragment key={`${questionIndex}-${sectionIndex}-${question.idQuestion}-fragment`}>
                            <FieldWrapper
                                key={`${questionIndex}-${sectionIndex}-${question.idQuestion}-wrapper`}
                                flex={question.behaviorObject.canCreatePerson || question.behaviorObject.extraDescriptionLeft || question.behaviorObject.displayFlex || question.behaviorObject.componentId === 'Switch'}
                                inline={question.behaviorObject.displayFlex}
                                borderTop={question.behaviorObject.displayFlex}
                                mobileWidth={question.behaviorObject.mobileWidth}
                                tabletWidth={question.behaviorObject.tabletWidth}
                                desktopWidth={question.behaviorObject.desktopWidth}
                                marginRight={question.behaviorObject.marginRight}
                                paddingRight={question.behaviorObject.paddingRight}
                            >
                                {(question.behaviorObject.extraDescriptionLeft) && (
                                    <Label
                                        hideLabelAsterisk={true}
                                        inline={true}
                                        width={100}
                                        style={{ alignSelf: 'center', marginBottom: 20 }}
                                        bold
                                    >
                                        {question.behaviorObject.extraDescriptionLeft}
                                    </Label>
                                )}

                                {question.idDomainQuestion === 614 && (sectionIndex == null || sectionIndex === 0) &&
                                    <Label
                                        hideLabelAsterisk={true}
                                        inline={true}
                                        style={{ alignSelf: 'flex-start', marginBottom: 20 }}
                                    >
                                        {question.dsQuestion}
                                    </Label>
                                }

                                {/* if question is type text, number, search or select */}
                                {(fieldComponent && question.behaviorObject.componentId !== 'Switch') ?
                                    <Field
                                        warning={showWarning ? warning : null}
                                        refused={showWarning ? refused : null}
                                        warningByHiddenQuestions={question.behaviorObject.isWarningByHiddenQuestions}
                                        refusedByHiddenQuestions={question.behaviorObject.isRefusedByHiddenQuestions}
                                        key={`${questionIndex}-${sectionIndex}-${question.idQuestion}-field`}
                                        extraLabelTop={question.behaviorObject.extraDescriptionTop}
                                        disabled={disableAll || question.disabled || (question.behaviorObject.isReadOnly)}
                                        readOnly={(question.behaviorObject.isReadOnly || question.behaviorObject.rightIcon === 'calendar')}
                                        mask={question.fieldMask}
                                        hasModal={question.behaviorObject.hasModal}
                                        modalDescription={question.behaviorObject.modalDescription}
                                        inline={question.behaviorObject.displayFlex}
                                        isRequired={question.behaviorObject.isRequired}
                                        hideLabelAsterisk={question.behaviorObject.hideDescription}
                                        name={question.key}
                                        fieldName={question.key}
                                        labelDEV={question.behaviorObject.hideDescription ? '' : `${question.dsQuestion}`}
                                        additionalInfo={question?.behaviorObject?.additionalInfo ? question.behaviorObject.additionalInfo : ''}
                                        infoContent={question?.behaviorObject?.textInformation ? question.behaviorObject.textInformation : ''}
                                        label={question.behaviorObject.hideDescription ? '' : `${question.dsQuestion}`}
                                        placeholder={question.behaviorObject.placeholder || ' '}
                                        type="text"
                                        onBlur={(value) => {
                                            onBlur && onBlur(question, value, setFieldValue, questionnaire)
                                            setTimeout(() => {
                                                searchZipCode(values && values[question.key], question.behaviorObject.searchQueryId, setFieldValue, question);
                                                searchSerpro(question, values && values[question.key], question.behaviorObject.searchQueryId, questionnaire, setFieldValue);
                                            }, 350)
                                        }}
                                        leftIcon={question.behaviorObject.leftIcon}
                                        leftIconText={question.behaviorObject.leftIconText}
                                        rightIcon={question.behaviorObject.rightIcon}
                                        rightIconComponent={extraButtonsQuestion && extraButtonsQuestion(question)}
                                        hideSearchIcon={question.behaviorObject.hideSearchIcon}
                                        rightIconClick={() => {
                                            if (question.behaviorObject.rightIcon === 'calendar') {
                                                if (disableAll || question.disabled || question.behaviorObject.isReadOnly) return;
                                                return setShowCalendar(!showCalendar.trim().length ? question.key : '')
                                            }

                                            if (disableAll || question.disabled || question.behaviorObject.isReadOnly) {
                                                setTimeout(() => {
                                                    searchSerpro(question, values && values[question.key], question.behaviorObject.searchQueryId, questionnaire, setFieldValue, true);
                                                    searchZipCode(values && values[question.key], question.behaviorObject.searchQueryId, setFieldValue, question);
                                                }, 350)
                                            }
                                        }}
                                        format={(value) => {
                                            if (question.idDomainQuestion !== 44) return;
                                            return value?.map(v => v.dsAnswerOption)?.join(', ') || ''
                                        }}
                                        component={fieldComponent}
                                        options={getOptions(question, idProduct, idDomainStatusFilter, permissions)}
                                        value={values && values[question.key]}
                                        onChange={(value) => {
                                            if (question.disabled || question.behaviorObject.isReadOnly || (question.behaviorObject.rightIcon === 'calendar' && value)) return;

                                            setFieldValue && setFieldValue(question.key, value);
                                            let questionnaireUpdated = questionnaire;

                                            if (!question.behaviorObject.searchQueryId || value === '') {
                                                const idAnswerOption = isObject(value) && value.idAnswerOption ? value.idAnswerOption : undefined;
                                                const answer = idAnswerOption ?
                                                    (value.resultValue != null ? value.resultValue : value.dsAnswerOption) :
                                                    isObject(value) ?
                                                        JSON.stringify(value) :
                                                        value;

                                                questionnaireUpdated = questionnaire.map(v => v.key === question.key ?
                                                    ({
                                                        ...v, idAnswerOption,
                                                        answer: answer === '' ? v.answerJson = '' : answer,
                                                        answerJson: idAnswerOption ? undefined : v.answerJson
                                                    }) : v)

                                                setQuestionnaire(questionnaireUpdated);
                                            }
                                            onQuestionChange && onQuestionChange(question, value, setFieldValue, questionnaireUpdated)
                                        }}
                                        searchRequest={searchRequest}
                                        debounceSearchRequest={debounceSearchRequest}
                                        question={question}
                                        canGenerate={question.behaviorObject.canGenerate || canGenerate}
                                        onSearchSelect={(selectedValue) => {
                                            if (selectedValue) {
                                                const questionnaireUpdated = questionnaire.map(v => v.key === question.key ? ({
                                                    ...v,
                                                    answerJson: JSON.stringify({ value: selectedValue.value, id: selectedValue.id }),
                                                    answer: JSON.stringify({ value: selectedValue.value, id: selectedValue.id })
                                                }) : v)

                                                setQuestionnaire(questionnaireUpdated);
                                                onQuestionChange && onQuestionChange(question, selectedValue, setFieldValue, questionnaireUpdated)
                                            }
                                        }}
                                    /> : <></>
                                }

                                {showCalendar && showCalendar === question.key ?
                                    <CalendarContainer isFlex={question.behaviorObject.displayFlex}>
                                        <DayPicker
                                            mode="single"
                                            fromYear={1900}
                                            toYear={2100}
                                            captionLayout="dropdown-buttons"
                                            style
                                            firstDayOfWeek={0}
                                            disabled={[{
                                                before: getDisableDays(question.behaviorObject?.fieldMinValue) || new Date(),
                                            }, {
                                                after: getDisableDays(question.behaviorObject?.fieldMaxValue),
                                            }]}
                                            fixedWeeks
                                            onDayClick={(date, { disabled }) => {
                                                if (disabled) return;
                                                let formattedDate = "";
                                                let selectedDate = "";
                                                let momentDate = moment(new Date(date));
                                                if (momentDate.isValid()) {
                                                    formattedDate = momentDate.format(question.behaviorObject.fieldDateFormat || 'MM/DD/YYYY');
                                                    selectedDate = momentDate.format("YYYY-MM-DD");
                                                }

                                                setFieldValue && setFieldValue(question.key, formattedDate);
                                                let questionnaireUpdated = questionnaire.map((v) => v.key === question.key ? { ...v, answer: selectedDate } : v);
                                                setQuestionnaire(questionnaireUpdated);
                                                setShowCalendar("");

                                                //optimization
                                                onQuestionChange && onQuestionChange(question, selectedDate, setFieldValue, questionnaireUpdated)
                                            }}
                                        ></DayPicker>
                                    </CalendarContainer>
                                    : <></>
                                }

                                {/* if question is type switch (yes or no) */}
                                {question.behaviorObject.componentId === 'Switch' ?
                                    <>
                                        <Label
                                            width={question.behaviorObject.width || 35}
                                            isRequired={question.behaviorObject.isRequired}
                                            inline={true}
                                            hideLabelAsterisk={!question.behaviorObject.isRequired}
                                            color={errors && errors[question.key] ? Colors.DANGER : false}
                                            error={errors && errors[question.key]}
                                        >
                                            {`${question.dsQuestion}\n`}
                                        </Label>
                                        <BorderSwitch error={errors && errors[question.key]}>
                                            <Switch
                                                disabled={disableAll || question.disabled}
                                                height={27}
                                                width={53}
                                                checked={values && values[question.key] && (values[question.key] === 'YES' || values[question.key].dsAnswerOption === 'YES' || values[question.key] === 'Yes' || values[question.key].dsAnswerOption === 'Yes' || values[question.key] == 'SIM' || values[question.key] == 'Sim' | values[question.key].dsAnswerOption === 'SIM' || values[question.key].dsAnswerOption === 'Sim')}
                                                onChange={(value) => {
                                                    setFieldError && (setFieldError(question.key, ""))
                                                    const answerOption = value
                                                        ? question.answerOptions.find(v => v.dsAnswerOption.toUpperCase() === "YES" || v.dsAnswerOption.toUpperCase() == "SIM")
                                                        : question.answerOptions.find(v => v.dsAnswerOption.toUpperCase() === "NO" || v.dsAnswerOption.toUpperCase() == "NÃO");

                                                    const questionnaireUpdated = questionnaire.map(v => v.key === question.key
                                                        ? ({
                                                            ...v,
                                                            answer: answerOption.dsAnswerOption,
                                                            idAnswerOption: answerOption.idAnswerOption,
                                                            answerJson: undefined
                                                        })
                                                        : v
                                                    )
                                                    setQuestionnaire(questionnaireUpdated);
                                                    setFieldValue && setFieldValue(question.key, answerOption.dsAnswerOption);
                                                    onQuestionChange && onQuestionChange(question, answerOption, setFieldValue, questionnaireUpdated)
                                                }}
                                                name={question.key}
                                                handleDiameter={20}
                                                checkedIcon={false}
                                                uncheckedIcon={false}
                                                offColor={Colors.WHITE}
                                                onColor={Colors.GRAY[6] || Colors.GREEN}
                                                offHandleColor={errors && errors[question.key] ? Colors.DANGER : Colors.GRAY[6]}
                                                onHandleColor={Colors.WHITE}
                                            />
                                        </BorderSwitch>
                                    </> : <></>}

                                {!disableAll && handleActionButtons(question)}
                            </FieldWrapper>
                            {(question.idDomainQuestion === 270 || question.idDomainQuestion === 271) &&
                                <DragZoneUpload
                                    autoUpload={question.behaviorObject?.disableAutoUpload ? false : values.autoUpload}
                                    show={values.showDragZone}
                                    multiple={!singleUpload}
                                    options={getOptions(question, idProduct, idDomainStatusFilter)}
                                    childrenOptions={question.childrenQuestions ? getOptions(question.childrenQuestions[0].idQuestion, idProduct, idDomainStatusFilter) : null}
                                    disabled={disableAll || question.disabled}
                                    documentTypeRequired={values.documentTypeRequired ? true : false}
                                    partiesDocuments={values.partiesDocuments}
                                    format={question.behaviorObject?.acceptedFileFormat}
                                    documentType={values.documentType || question.answerOptions[0]}
                                    isDraft={true}
                                    description={question.dsQuestion || null}
                                    labelDescription={question.behaviorObject?.labelDescription}
                                    periodicityOptions={periodicityOptions}
                                    endorsementEdit={sectionName === 'ENDORSEMENT_EDIT'}
                                    showDragZoneText={ values.showDragZoneText && values.showDragZoneText}
                                    dsInsurer={question.dsInsurer && question.dsInsurer}
                                    periodicityText={periodicityText}
                                    onSuccess={(uploadedFiles) => {
                                        if (!question.answer) question.answer = [];
                                        const questionnaireUpdated = questionnaire.map(v =>{ 
                                                if(v.key === question.key){
                                                    let {answer} = v;

                                                    if(!answer || answer === '[]') answer = [];

                                                    if (Array.isArray(answer)) answer.push(...uploadedFiles);

                                                    if(singleUpload) answer = uploadedFiles

                                                    return {
                                                        ...question,
                                                        answer,
                                                        answerJson: answer
                                                    }
                                                } else {
                                                    return v;
                                                }
                                            }
                                        )
                                        setQuestionnaire(questionnaireUpdated);
                                        setFieldValue && setFieldValue(question.key, singleUpload ? uploadedFiles : [...question.answer, ...uploadedFiles])
                                        onQuestionChange && onQuestionChange(question, uploadedFiles, setFieldValue, questionnaireUpdated)
                                    }}
                                    question={question}
                                    idOperation={idOperation}
                                    translateText={ values.translateText ? true : false }
                                    notShowColumns={ values.notShowColumns ? true : false }
                                />
                            }

                            {isModalVisible && (
                                <ModalConfirmation
                                    show={isModalVisible}
                                    onConfirm={confirmDelete}
                                    onCancel={confirmCancel}
                                    title="Confirmação de exclusão"
                                    text="Você tem certeza que deseja deletar este anexo?"
                                    textButtonCancel="Não"
                                    textButtonConfirm="Sim"
                                />
                            )}

                            {((question.idDomainQuestion === 270 || question.idDomainQuestion === 271) && !values?.ignoreAttachmentsDisplay) ? <FieldWrapper
                                mobileWidth={100}
                                tabletWidth={100}
                                desktopWidth={100}
                            >
                                {
                                    sectionName === 'ENDORSEMENT_EDIT' 
                                    ?
                                        (
                                            <EndorsementTagList
                                                tags={ question.answer || []}
                                                removeTag={(tagId) => {
                                                    const questionnaireUpdated = questionnaire.map((qst) => qst.key === question.key
                                                        ?({
                                                            ...qst,
                                                            answer: question.answer.filter(attachment => attachment.documentId !== tagId),
                                                            answerJson: question.answer.filter(attachment => attachment.documentId !== tagId)
                                                        })  
                                                        : qst
                                                )

                                                    setQuestionnaire(questionnaireUpdated);
                                                }}
                                                showRemoveIcon
                                                idOperation={idOperation}
                                                contextApp={contextOfApp}
                                            />
                                        )
                                    :   
                                        (
                                            <>
                                                {question.behaviorObject?.ignoreTagList ? (
                                                    <></>
                                                ) : (
                                                    <TagsList
                                                        disabled={disableAll || question.disabled}
                                                        labelDescription={question.behaviorObject?.labelDescription}
                                                        tags={question.answer || []}
                                                        idOperation={idOperation}
                                                        contextApp={contextOfApp}
                                                        expireDocumentOnRemove={question.behaviorObject?.expireDocumentOnRemove}
                                                        updateIsLoadingStatus={updateIsLoadingStatus}
                                                        removeTag={(currentAttachment) => {
                                                            const questionnaireUpdated = questionnaire.map(v => v.key === question.key
                                                                ? ({
                                                                    ...v,
                                                                    answer: question.answer.map(attachment => question.answer.indexOf(attachment) === currentAttachment ? ({ ...attachment, deleteAttachment: true }) : attachment),
                                                                    answerJson: question.answer.map(attachment => question.answer.indexOf(attachment) === currentAttachment ? ({ ...attachment, deleteAttachment: true }) : attachment),
                                                                })
                                                                : v
                                                            )
                                                            setQuestionnaire(questionnaireUpdated);
                                                            setFieldValue && setFieldValue(question.key, question.answer.map(attachment => question.answer.indexOf(attachment) === currentAttachment ? ({ ...attachment, deleteAttachment: true }) : attachment))
                                                            onQuestionChange && onQuestionChange(question, currentAttachment, setFieldValue, questionnaireUpdated)
                                                        }}
                                                    />
                                                )}
                                            </>
                                        )
                                }
                            </FieldWrapper> : <></>}

                            {question.behaviorObject?.bottomSeparatorLine && <BottomSeparatorLine />}
                        </React.Fragment>
                        {extraButtonsAfterQuestion && extraButtonsAfterQuestion(question)}
                    </>)
                })}
            {(!disableAll) && extraButtons && extraButtons()}
        </Container>
    );
}
